<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-table-cells-large">
    {{ t("global.board") }}: {{ result?.SQDCBoards[0]?.name ?? filter.boardId }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTranslation } from "@/language/translation";
import { useSQDCBoardsForSelectQuery } from "@/graphql";
import BoardFilter from "../../filterImplementations/BoardFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps<{ filter: BoardFilter }>();
const { t } = useTranslation();
const { result } = useSQDCBoardsForSelectQuery(computed(() => ({ ids: [props.filter.boardId] })));
</script>
